export default {
  _id: '00000000-55d5-ef82-6de8-e0531944e434',
  _created: new Date('2015-08-20T15:17:22.578Z'),
  _updated: new Date('2015-08-20T15:17:22.578Z'),
  name: 'Anonymous',
};
